import React from 'react';
import { withRouter } from 'react-router-dom';

const NavLinkComponent = ({ to, className = "", style = {}, children, history }) => {
    return (
        <a onClick={() => history.push(to)} className={className} style={style}>{children}</a>
    )
};

export const NavLink = withRouter(NavLinkComponent);